import { useState, useEffect } from 'react';
import { Card, Btn, Input, Field, Pagination, usePagination } from '../../components/UI';
import NrpLookup from '../../components/NrpLookup';
import { useToast } from '../../components/Toast';
import { minseldikAPI } from '../../utils/api';
import { exportCSV, printTable } from '../../utils/exportHelper';

const selStyle = { width:'100%', padding:'8px 12px', border:'1.5px solid #E5E7EB', borderRadius:8,
  fontSize:13, outline:'none', boxSizing:'border-box', fontFamily:'inherit', background:'white' };

const th = { padding:'10px 14px',textAlign:'left',fontSize:12,fontWeight:700,color:'#64748B',borderBottom:'2px solid #E2E8F0' };
const td = { padding:'10px 14px',fontSize:13,borderBottom:'1px solid #F1F5F9' };

// ── UPLOAD USULAN SELDIK ──────────────────────────────────
const UploadTab = () => {
  const [file, setFile] = useState(null);
  const [pendidikan, setPendidikan] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { toast: show } = useToast();
  const pgUpload = usePagination(10);
  useEffect(() => { pgUpload.reset(); }, [data]);

  useEffect(() => {
    minseldikAPI.getUpload().then(r => setData(r.data || [])).catch(() => {});
  }, []);

  const handleUpload = async () => {
    if (!file) return show('Pilih file terlebih dahulu', 'error');
    setLoading(true);
    try {
      await minseldikAPI.createUpload({ jenis_pendidikan: pendidikan, file_nama: file.name });
      show('Upload berhasil');
      minseldikAPI.getUpload().then(r => setData(r.data || [])).catch(() => {});
    } catch (e) { show(e.message, 'error'); }
    finally { setLoading(false); }
  };

  return (
    <>
      <Card>
        <h3 style={{ margin:'0 0 16px',fontSize:15,fontWeight:700 }}>Upload Usulan Seldik</h3>
        <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16 }}>
          <Field label="Jenis Pendidikan">
            <select value={pendidikan} onChange={e => setPendidikan(e.target.value)} style={selStyle}>
              <option value="">— Pilih Pendidikan —</option>
              <option value="SELDIK">SELDIK</option>
              <option value="DIKMIL">DIKMIL</option>
            </select>
          </Field>
          <Field label="Pilih File (Excel)">
            <input type="file" onChange={e => setFile(e.target.files[0])}
              style={{ padding:'6px 12px', border:'1.5px solid #E5E7EB', borderRadius:8, fontSize:13, boxSizing:'border-box' }}/>
          </Field>
        </div>
        <Btn onClick={handleUpload} disabled={loading}>{loading ? 'Mengupload...' : 'Upload'}</Btn>
        <p style={{ fontSize:11,color:'#9CA3AF',marginTop:8 }}>
          *Gunakan format dan contoh format file upload, perhatikan header dan penulisan baris data sesuai.
        </p>
      </Card>
      <Card>
        <h3 style={{ margin:'0 0 12px',fontSize:15,fontWeight:700 }}>Data Upload ({data.length})</h3>
        {(() => { const { data: paged, total, totalPages, from, to } = pgUpload.paginate(data); return (<>
        <table style={{ width:'100%',borderCollapse:'collapse' }}>
          <thead><tr style={{ background:'#F8FAFC' }}>
            {['No','Jenis Pendidikan','File','Jumlah Data','Tanggal'].map(h => <th key={h} style={th}>{h}</th>)}
          </tr></thead>
          <tbody>
            {paged.length === 0
              ? <tr><td colSpan={5} style={{ ...td,textAlign:'center',color:'#9CA3AF' }}>Belum ada data upload</td></tr>
              : paged.map((r,i) => (
                <tr key={i}>
                  <td style={td}>{from + i}</td>
                  <td style={td}>{r.jenis_pendidikan}</td>
                  <td style={td}>{r.file_nama}</td>
                  <td style={td}>{r.jumlah_data || 0}</td>
                  <td style={td}>{r.created_at ? new Date(r.created_at).toLocaleDateString('id-ID') : '-'}</td>
                </tr>
              ))}
          </tbody>
        </table>
        <Pagination page={pgUpload.page} totalPages={totalPages} total={total} from={from} to={to} pageSize={pgUpload.pageSize} onPageChange={pgUpload.setPage} onPageSizeChange={pgUpload.setPageSize} />
        </>); })()}
      </Card>
    </>
  );
};

// ── DAFTAR PENILAIAN ──────────────────────────────────────
const PenilaianTab = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [form, setForm] = useState({ nrp:'', nama:'', nilai:'', keterangan:'' });
  const [selPers, setSelPers] = useState(null);
  const { toast: show } = useToast();
  const pgPenilaian = usePagination(10);
  useEffect(() => { pgPenilaian.reset(); }, [data]);

  const load = async () => {
    setLoading(true);
    try { const r = await minseldikAPI.getPenilaian(search ? `?search=${search}` : ''); setData(r.data || []); }
    catch {} finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [search]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nrp) return show('NRP wajib diisi', 'error');
    try {
      await minseldikAPI.createPenilaian(form);
      show('Data penilaian berhasil disimpan');
      setForm({ nrp:'', nama:'', nilai:'', keterangan:'' });
      setSelPers(null);
      load();
    } catch(e) { show(e.message,'error'); }
  };

  return (
    <>
      <Card>
        <h3 style={{ margin:'0 0 16px',fontSize:15,fontWeight:700 }}>Tambah Penilaian Pendidikan Minseldik</h3>
        <form onSubmit={handleSubmit}>
          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16 }}>
            <Field label="NRP Personel" required><NrpLookup value={selPers} onSelect={(p) => { setSelPers(p); setForm(f=>({...f, nrp: p.nrp, nama: p.nama})); }} onClear={() => { setSelPers(null); setForm(f=>({...f, nrp:'', nama:''})); }} /></Field>
            <Field label="Nilai"><Input type="number" value={form.nilai} onChange={e => setForm(f=>({...f,nilai:e.target.value}))} placeholder="0-100"/></Field>
            <Field label="Keterangan"><Input value={form.keterangan} onChange={e => setForm(f=>({...f,keterangan:e.target.value}))} placeholder="Keterangan"/></Field>
          </div>
          <Btn>Simpan Penilaian</Btn>
        </form>
      </Card>
      <Card>
        <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12 }}>
          <h3 style={{ margin:0,fontSize:15,fontWeight:700 }}>Daftar Penilaian ({data.length})</h3>
          <div style={{ display:'flex',gap:6,alignItems:'center' }}>
            <Input placeholder="Cari NRP / Nama..." value={search} onChange={e => setSearch(e.target.value)} style={{ width:220 }}/>
            <Btn size="sm" variant="ghost" onClick={() => { const h=['NRP','Nama','Nilai','Keterangan']; exportCSV('minseldik_penilaian', h, data.map(r=>[r.nrp,r.nama,r.nilai,r.keterangan])); }}>CSV</Btn>
            <Btn size="sm" variant="ghost" onClick={() => { const h=['NRP','Nama','Nilai','Keterangan']; printTable('Penilaian Minseldik', h, data.map(r=>[r.nrp,r.nama,r.nilai,r.keterangan])); }}>Print</Btn>
          </div>
        </div>
        {loading ? <p>Loading...</p> : (
          (() => { const { data: paged, total, totalPages, from, to } = pgPenilaian.paginate(data); return (<>
          <table style={{ width:'100%',borderCollapse:'collapse' }}>
            <thead><tr style={{ background:'#F8FAFC' }}>
              {['NRP','Nama','Nilai','Keterangan','Aksi'].map(h => <th key={h} style={th}>{h}</th>)}
            </tr></thead>
            <tbody>
              {paged.length === 0
                ? <tr><td colSpan={5} style={{ ...td,textAlign:'center',color:'#9CA3AF' }}>Belum ada data penilaian</td></tr>
                : paged.map((r,i) => (
                  <tr key={i}>
                    <td style={td}>{r.nrp}</td>
                    <td style={td}>{r.nama}</td>
                    <td style={td}>{r.nilai}</td>
                    <td style={td}>{r.keterangan || '-'}</td>
                    <td style={td}>
                      <Btn variant="danger" onClick={async() => { try { await minseldikAPI.deletePenilaian(r.id); load(); } catch(e){show(e.message,'error');} }}>Hapus</Btn>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <Pagination page={pgPenilaian.page} totalPages={totalPages} total={total} from={from} to={to} pageSize={pgPenilaian.pageSize} onPageChange={pgPenilaian.setPage} onPageSizeChange={pgPenilaian.setPageSize} />
          </>); })()
        )}
      </Card>
    </>
  );
};

// ── DAFTAR HISTORY ────────────────────────────────────────
const HistoryTab = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const pgHistory = usePagination(10);
  useEffect(() => { pgHistory.reset(); }, [data]);

  const load = async () => {
    setLoading(true);
    try { const r = await minseldikAPI.getHistory(search ? `?search=${search}` : ''); setData(r.data || []); }
    catch {} finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [search]);

  return (
    <Card>
      <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12 }}>
        <h3 style={{ margin:0,fontSize:15,fontWeight:700 }}>Daftar History Pendidikan Minseldik ({data.length})</h3>
        <Input placeholder="Cari NRP / Nama..." value={search} onChange={e => setSearch(e.target.value)} style={{ width:220 }}/>
      </div>
      {loading ? <p>Loading...</p> : (
        (() => { const { data: paged, total, totalPages, from, to } = pgHistory.paginate(data); return (<>
        <table style={{ width:'100%',borderCollapse:'collapse' }}>
          <thead><tr style={{ background:'#F8FAFC' }}>
            {['NRP','Nama','Jenis Pendidikan','Tahun','Nilai','Keterangan'].map(h => <th key={h} style={th}>{h}</th>)}
          </tr></thead>
          <tbody>
            {paged.length === 0
              ? <tr><td colSpan={6} style={{ ...td,textAlign:'center',color:'#9CA3AF' }}>Belum ada data history</td></tr>
              : paged.map((r,i) => (
                <tr key={i}>
                  <td style={td}>{r.nrp}</td>
                  <td style={td}>{r.nama}</td>
                  <td style={td}>{r.jenis_pendidikan}</td>
                  <td style={td}>{r.tahun}</td>
                  <td style={td}>{r.nilai}</td>
                  <td style={td}>{r.keterangan || '-'}</td>
                </tr>
              ))}
          </tbody>
        </table>
        <Pagination page={pgHistory.page} totalPages={totalPages} total={total} from={from} to={to} pageSize={pgHistory.pageSize} onPageChange={pgHistory.setPage} onPageSizeChange={pgHistory.setPageSize} />
        </>); })()
      )}
    </Card>
  );
};

// ── MAIN ─────────────────────────────────────────────────
export default function MinseldikPage() {
  const [tab, setTab] = useState('upload');
  const tabs = [
    { id:'upload',    label:'Upload Usulan Seldik' },
    { id:'penilaian', label:'Daftar Penilaian' },
    { id:'history',   label:'Daftar History Pendidikan' },
  ];
  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <h1 style={{ fontSize:22,fontWeight:700,color:'#111827',margin:0 }}>Minseldik</h1>
        <p style={{ color:'#6B7280',fontSize:13,margin:'4px 0 0' }}>Manajemen Seleksi Pendidikan</p>
      </div>
      <div style={{ display:'flex',gap:0,marginBottom:20,borderBottom:'2px solid #E5E7EB' }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{ padding:'10px 20px',border:'none',background:'none',cursor:'pointer',
              fontSize:13,fontWeight:tab===t.id?700:500,
              color:tab===t.id?'#2563EB':'#6B7280',
              borderBottom:tab===t.id?'2px solid #2563EB':'2px solid transparent',
              marginBottom:-2,fontFamily:'inherit',whiteSpace:'nowrap' }}>
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'upload'    && <UploadTab/>}
      {tab === 'penilaian' && <PenilaianTab/>}
      {tab === 'history'   && <HistoryTab/>}
    </div>
  );
}
